import { dateTimeService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  authService,
  accountsService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { getActionStatusName } from './helpers';
import { GET_CALL_PLANS } from './actionTypes';

export const accountTimezoneId = state =>
  state.currentAccount && state.currentAccount.timeZoneId;

export const accountTranslatedTimeZoneId = (state, getters) => {
  return (
    state.currentAccount &&
    dateTimeService.getTimeZoneMapping(getters.accountTimezoneId)
  );
};

export const recentlyUsedTags = state => formName =>
  state.recentlyUsedTags[formName] || [];

export const isAdmin = state => {
  const roles = state.currentAccountPermissions?.roles || [];

  return roles.indexOf('admin') > -1;
};

export const isPublisher = state => {
  const roles = state.currentAccountPermissions?.roles || [];

  return roles.length === 1 && roles[0] === 'affiliate';
};

export const isBuyer = state => {
  const roles = state.currentAccountPermissions?.roles || [];

  return roles.length === 1 && roles[0] === 'buyer';
};

export const isPublisherGroupUser = state => {
  const roles = state.currentAccountPermissions?.roles || [];

  return roles.length === 1 && roles[0] === 'affiliate_manager';
};

export const isBuyerGroupUser = state => {
  const roles = state.currentAccountPermissions?.roles || [];

  return roles.length === 1 && roles[0] === 'buyer_manager';
};

export const isReadOnlyReportUser = state => {
  const roles = state.currentAccountPermissions?.roles || [];

  return roles.length === 1 && roles[0] === 'user';
};

export const inAdminReportViewGroup = state => {
  return state.currentAccountUserGroups.some(g => g.adminReportView);
};

export const inReadOnlyGroup = state => {
  return (
    !!state.currentAccountUserGroups?.length &&
    state.currentAccountUserGroups.every(g => g.readOnly)
  );
};

export const accountUserRole = (state, getters) => {
  if (getters.isAdmin) {
    return 'admin';
  } else if (getters.isBuyer || getters.isBuyerGroupUser) {
    return 'buyer';
  } else if (getters.isPublisher || getters.isPublisherGroupUser) {
    return 'publisher';
  } else if (getters.isReadOnlyReportUser) {
    return 'user';
  }

  return 'error';
};

export const icpFeatureFlag = state => {
  return state.currentAccountFeatureFlags.dataenrichment;
};

export const changeLogFeatureFlag = state => {
  const isAdmin = accountsService.isAdmin();
  return (
    authService.authentication.isSuper ||
    (isAdmin && state.currentAccountFeatureFlags.changelog)
  );
};

export const monthlyInvoiceFeatureFlag = state => {
  return state.currentAccountFeatureFlags.monthlyInvoice;
};

export const hasAccessToItem = (state, getters) => (itemType, permission) => {
  if (getters.isAdmin) {
    return true;
  }

  let access = false;
  const item = state.currentAccountItemPermissions.find(
    item => item.type === itemType
  );

  if (typeof item !== 'undefined') {
    if (item.permissions.includes(permission)) {
      access = true;
    }
  }

  return access;
};

export const getCallPlansStatus = state =>
  state.status[getActionStatusName(GET_CALL_PLANS)] || {};

export const hasFeatureFlag = state => flag =>
  !!state.currentAccountFeatureFlags[flag];

export const hasRpc = (_, getters) => {
  return getters.hasFeatureFlag('rpc');
};

export const hasRevenueRecovery = (_, getters) => {
  return getters.hasFeatureFlag('hangup_rerout');
};
